import { Theme, css } from '@emotion/react'
import { alpha } from '@mui/material/styles'

export const title = (theme: Theme) => css`
  font-weight: 700;
  color: ${theme.typographyColors.typographyTwo};
`

export const content = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const buttonsWrapper = css`
  width: 100%;
  display: flex;
  gap: 10px;
  margin-top: 5px;
`

export const warning = (theme: Theme) => css`
  color: ${theme.colors.red};
  background: ${alpha(theme.colors.red, 0.1)};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  padding: 12px 16px;
  border-radius: 16px;
  margin-top: 5px;
`
